module.exports = __webpack_public_path__ + "static/media/cocoroboPatternIcon.b47c54ad.svg";